export function decisionAsset(key: string): string {
  return `/assets/decisions/${key}.webp`
}
